import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAllSub_Property = createAsyncThunk(
  "masters/subproperty/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Sub_Property}?name=${filter?.name || ""}&property_type_id=${
          filter?.property_type_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get a specific Property
export const GetSub_Property = createAsyncThunk(
  "masters/subproperty/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Sub_Property}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create a new Property
export const AddSub_Property = createAsyncThunk(
  "masters/subproperty/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Sub_Property, data);
      return res; // The new Property object
    } catch (error) {
      console.log(error, "error Property");
      return rejectWithValue(error);
    }
  }
);
// Update a Property
export const UpdateSub_Property = createAsyncThunk(
  "masters/subproperty/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Sub_Property}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


// Delete a Property
export const DeleteSub_Property = createAsyncThunk(
  "masters/subproperty/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Sub_Property}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Change the status of a Property
export const StatusSub_Property = createAsyncThunk(
  "masters/subproperty/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Sub_Property}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "subproperty",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(UpdateSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeleteSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (stateItem) => stateItem.id !== action.payload
        );
        // state.data = state.data.filter(
        //   (stateItem) => stateItem.id !== action.payload
        // );
      })
      .addCase(DeleteSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(StatusSub_Property.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusSub_Property.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      })
      .addCase(StatusSub_Property.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
